"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoMeeting/VideoCallOverlay.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _lodash = require('lodash');
var _utils = require('shared/utils');

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _OnCall = require('web/screens/VideoCall/OnCall'); var _OnCall2 = _interopRequireDefault(_OnCall);


// Quadrants map: 1 | 2
//                --+--
//                3 | 4































const initialState = {
  isDragging: false,
  floatingPosition: {},
  snappedQuadrant: 4,
}

const VideoCallOverlay = ({
  showNoticeBar,
  openMobileMoreOptionsModal,
  openSettingsModal,
  isNetstatsModalOpen,
  openNetstatsModal,
  closeNetstatsModal,
  onRoomLinkCopy,
  onRoomShare,
  isMinimizable,
  isMinimized,
  handleMinimization,
  onCallJoinFailed,
  onGracefulExit,
  onForcefulExit,
}) => {
  const [state, setClassState] = _react.useState.call(void 0, initialState)
  // Merges like the class's setState.
  const setState = _react.useCallback.call(void 0, (patch) =>
    setClassState(s => ({ ...s, ...patch })), [])
  const { isDragging, floatingPosition, snappedQuadrant } = state

  // The class handlers read `this.props`/`this.state` when called (including
  // from timers and document listeners); this ref gives the stable callbacks
  // below the same latest values.
  const latest = _react.useRef.call(void 0, { isMinimized, handleMinimization, state })
  _react.useLayoutEffect.call(void 0, () => {
    latest.current = { isMinimized, handleMinimization, state }
  })

  // Instance fields in the class.
  const wrapperRef = _react.useRef(null)
  const wrapperBounds = _react.useRef(null)

  const handleMinimize = _react.useCallback.call(void 0, () => latest.current.handleMinimization(true), [])
  const handleMaximize = _react.useCallback.call(void 0, () => {
    const { isMinimized, handleMinimization, state } = latest.current
    if (isMinimized && !state.isDragging) handleMinimization(false)
  }, [])

  const setWrapperRef = _react.useCallback.call(void 0, (r) => { wrapperRef.current = r }, [])
  const setWrapperBounds = _react.useCallback.call(void 0, () => {
    wrapperBounds.current =
      wrapperRef.current && wrapperRef.current.getBoundingClientRect()
  }, [])

  const getWrapperWidth = _react.useCallback.call(void 0, () => !wrapperBounds.current
    ? 0
    : wrapperBounds.current.right - wrapperBounds.current.left, [])

  const getWrapperHeight = _react.useCallback.call(void 0, () => !wrapperBounds.current
    ? 0
    : wrapperBounds.current.bottom - wrapperBounds.current.top, [])

  const updatePosition = _react.useCallback.call(void 0, ({ clientX, clientY }) => {
    if (!wrapperRef.current) return

    const wrapperWidth = getWrapperWidth()
    const wrapperHeight = getWrapperHeight()
    const { innerWidth, innerHeight } = window

    const maxLeft = innerWidth - wrapperWidth - 10
    const maxTop = innerHeight - wrapperHeight - 10

    const floatingPosition = {
      left: _utils.clamp.call(void 0, 10, maxLeft)(clientX - wrapperWidth / 2),
      top: _utils.clamp.call(void 0, 10, maxTop)(clientY - wrapperHeight / 2),
    }
    setState({ floatingPosition })
  }, [getWrapperWidth, getWrapperHeight, setState])

  const startDragging = _react.useCallback.call(void 0, (e) => {
    e.persist()
    setWrapperBounds()
    setTimeout(() => {
      if (!latest.current.isMinimized) return
      setState({ isDragging: true })
      updatePosition(e)
    }, 300)
  }, [setWrapperBounds, setState, updatePosition])

  // One throttled function per mounted overlay, like the class field
  // (updatePosition is stable, so the initialiser's closure never goes stale).
  const [drag] = _react.useState.call(void 0, () => _lodash.throttle.call(void 0, updatePosition, 50))

  const releaseDrag = _react.useCallback.call(void 0, () => {
    const { floatingPosition } = latest.current.state
    const { innerWidth, innerHeight } = window
    const wrapperWidth = getWrapperWidth()
    const wrapperHeight = getWrapperHeight()
    // Unset while no drag position was recorded; the comparisons are then
    // false, as in JS.
    const left = floatingPosition.left 
    const top = floatingPosition.top 

    let snappedQuadrant = 1

    if (left + wrapperWidth / 2 < innerWidth / 2) {
      if (top + wrapperHeight / 2 < innerHeight / 2) { snappedQuadrant = 1 } else snappedQuadrant = 3
    } else {
      if (top + wrapperHeight / 2 < innerHeight / 2) { snappedQuadrant = 2 } else snappedQuadrant = 4
    }

    setTimeout(() =>
      setState({
        isDragging: false,
        floatingPosition: {},
        snappedQuadrant,
      })
    , 50)
  }, [getWrapperWidth, getWrapperHeight, setState])

  // The class bound these in componentDidUpdate when isDragging became true
  // and removed them when it became false or on unmount; the cleanup does the
  // removal in the same commit phase. (A change of isMinimized while dragging
  // re-added the same listeners, which was a no-op.)
  _react.useLayoutEffect.call(void 0, () => {
    if (!isDragging) return undefined
    document.addEventListener('mousemove', drag)
    document.addEventListener('mouseup', releaseDrag)
    return () => {
      document.removeEventListener('mousemove', drag)
      document.removeEventListener('mouseup', releaseDrag)
    }
  }, [isDragging, drag, releaseDrag])

  const rootClassName = _classBuilder2.default.call(void 0, 
    "video-call--floating-wrapper",
    { mini: isMinimized, dragging: isDragging },
    isMinimized && !isDragging && {
      'quadrant--top-left': snappedQuadrant === 1,
      'quadrant--top-right': snappedQuadrant === 2,
      'quadrant--bottom-left': snappedQuadrant === 3,
      'quadrant--bottom-right': snappedQuadrant === 4,
    },
  )

  const minimizedProps = isMinimized &&
    { onMouseDown: startDragging }
  const floatingProps = isMinimized && isDragging
    ? { style: floatingPosition }
    : { onClick: handleMaximize }

  return (
    _react2.default.createElement('div', {
      ref: setWrapperRef,
      className: rootClassName,
      ...floatingProps,
      ...minimizedProps, __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}}

      , _react2.default.createElement(_OnCall2.default, {
        showNoticeBar: showNoticeBar,
        openMobileMoreOptionsModal: openMobileMoreOptionsModal,
        openSettingsModal: openSettingsModal,
        isNetstatsModalOpen: isNetstatsModalOpen,
        openNetstatsModal: openNetstatsModal,
        closeNetstatsModal: closeNetstatsModal,
        onRoomLinkCopy: onRoomLinkCopy,
        onRoomShare: onRoomShare,
        isMinimized: isMinimized,
        isMinimizable: isMinimizable,
        onMinimize: handleMinimize,
        onCallJoinFailed: onCallJoinFailed,
        onGracefulExit: onGracefulExit,
        onForcefulExit: onForcefulExit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 199}}
      )
    )
  )
}

exports. default = VideoCallOverlay
